import {
    AuthenticatedGlobalContext,
    AuthenticatedGlobalContextValue
} from '~/providers/base-global-context/authenticated-global.context';
import { useGlobal } from '~/providers/global.provider';

// This hook is a temporary hook, this is part of the first milestone of creating a better seperated and slim react bundle.
// In the future we want to brake the root stores but for now we don't have a workaround.
// PLEASE use this hook only for things that are under the base store.
export function useAuthenticatedGlobalContext(): AuthenticatedGlobalContextValue {
    const globalContext = useGlobal<AuthenticatedGlobalContext>(
        AuthenticatedGlobalContext
    );

    if (!globalContext) {
        // To dev comment
        throw new Error(
            'You forgot to init both global context and cx global context, please use "init" before using any context related functions.'
        );
    }

    return globalContext;
}
